import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
import { Check, Clock, Users } from 'lucide-react';
export function KickboxingPage() {
  useEffect(() => {
    document.title = "Kickboxing Classes | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  const ageGroups = [{
    name: 'Kids Kickboxing',
    age: 'Ages 6-11',
    description: 'High-energy classes that build fitness, coordination, and confidence through kickboxing techniques.',
    schedule: 'Monday & Wednesday: 5:15 PM - 6:00 PM'
  }, {
    name: 'Teen & Adult Kickboxing',
    age: 'Ages 12+',
    description: 'Intense cardio workout combining punches, kicks, and conditioning for maximum fitness results.',
    schedule: 'Monday & Wednesday: 7:15 PM - 8:00 PM'
  }];
  return <div className="bg-black min-h-screen" data-id="element-1330">
      <Navigation data-id="element-1331" />

      {/* Hero Section */}
      <div className="relative pt-32 pb-20 overflow-hidden" data-id="element-1332">
        <div className="absolute inset-0 z-0" data-id="element-1333">
          <img src="https://images.squarespace-cdn.com/content/v1/6782c238cf9313348308674a/1736784617025-Z0BI14DKFMDG7TSB8AQ1/gabriel+alilah+belt+champions+2.png" alt="Kickboxing" className="w-full h-full object-cover opacity-20" data-id="element-1334" />
          <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black" data-id="element-1335" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1336">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1337">
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-1338">
              <span className="text-[#00D4FF]" data-id="element-1339">Kickboxing</span> Classes
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-1340">
              High-intensity cardio workout combining martial arts techniques
              with fitness training. Get in the best shape of your life.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Age Groups */}
      <section className="py-20 bg-[#0a0a0a]" data-id="element-1341">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1342">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-1343">
            Classes by Age Group
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1344">
            {ageGroups.map((group, index) => <motion.div key={group.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-1345">
                <div className="flex items-center gap-3 mb-4" data-id="element-1346">
                  <Users className="w-6 h-6 text-[#00D4FF]" data-id="element-1347" />
                  <h3 className="text-2xl font-bold text-white" data-id="element-1348">
                    {group.name}
                  </h3>
                </div>
                <p className="text-[#00D4FF] font-semibold mb-4" data-id="element-1349">{group.age}</p>
                <p className="text-gray-400 mb-6" data-id="element-1350">{group.description}</p>
                <div className="flex items-start gap-2 text-sm text-gray-500" data-id="element-1351">
                  <Clock className="w-4 h-4 mt-0.5 shrink-0" data-id="element-1352" />
                  <p data-id="element-1353">{group.schedule}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 bg-black" data-id="element-1354">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1355">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1356">
            <div data-id="element-1357">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1358">
                Why Choose Kickboxing?
              </h2>
              <div className="space-y-4" data-id="element-1359">
                {['Burn calories and lose weight with high-intensity cardio', 'Build strength, speed, and endurance', 'Learn practical striking techniques', 'Reduce stress and boost confidence', 'Improve coordination and agility', 'Fun, energetic group atmosphere'].map(benefit => <div key={benefit} className="flex items-start gap-3" data-id="element-1360">
                    <Check className="w-5 h-5 text-[#00D4FF] shrink-0 mt-1" data-id="element-1361" />
                    <p className="text-gray-300" data-id="element-1362">{benefit}</p>
                  </div>)}
              </div>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden" data-id="element-1363">
              <img src="https://cdn.magicpatterns.com/uploads/fdv7uYrgpVAsisHSRyqjwd/gabriel_belt.png" alt="Kickboxing Training" className="w-full h-full object-cover object-top" data-id="element-1364" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-1365" />
            </div>
          </div>
        </div>
      </section>

      <CTASection data-id="element-1366" />
      <Footer data-id="element-1367" />
    </div>;
}